import React, { Component } from 'react';
import ConstElement from '../../common/ConstElement';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { getSelectedList,updateStateJobs,initSelectedIdList } from "./service";
var EXIF = require("exif-js");

const MAX_NUMBER_IMAGES = 3;
const LIMIT_SIZE_UPLOAD = 10485760;

class CopyJob extends Component {
    constructor(props) {
        super(props);
        this.state = {
            jobs: props.jobs.length ? props.jobs : [],
            cities:[],
            prefs:[],
            bigCategories:[],
            smallCategories:[],
            disable: false,
            bulk_post_period_start_date: null,
            bulk_post_period_end_date: null,
        }
        this.saveData = this.saveData.bind(this);
        this.getData = this.getData.bind(this);
        this.setData = this.setData.bind(this);
        this.getJobByIds = this.getJobByIds.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleChangeEditPostPeriodStartDate = this.handleChangeEditPostPeriodStartDate.bind(this);
        this.handleChangeEditPostPeriodEndDate = this.handleChangeEditPostPeriodEndDate.bind(this);
        this.handleChangeBulkEditPostPeriodStartDate = this.handleChangeBulkEditPostPeriodStartDate.bind(this);
        this.handleChangeBulkEditPostPeriodEndDate = this.handleChangeBulkEditPostPeriodEndDate.bind(this);
    }

    /**
     * Init data
     */
    componentWillMount() {
        // axios.get('/api/cities').then(response => {
        //     this.setState({
        //         cities: response.data
        //     });
        // })
        // axios.get('/api/prefs2').then(response => {
        //     this.setState({
        //         prefs: response.data
        //     });
        // })
        // axios.get('/api/big-categories').then(response => {
        //     this.setState({
        //         bigCategories: response.data
        //     });
        // })
        // axios.get('/api/small-categories').then(response => {
        //     this.setState({
        //         smallCategories: response.data
        //     });
        // })

        if (this.props.jobs.length) {

        } else {
            this.getJobByIds();
        }
    }
    getJobByIds() {
        const data = {
            jobIds: this.props.selectedJobIds
        }
        // const data = {
        //     jobIds: [15476,15478]
        // }

        this.props.dispatch(
            getSelectedList(Object.assign({}, data))
        );
        // axios.post('/api/houjin/jobs/selected', data).then(response => {
        //     if (response.data.data) {
        //         this.setData(response.data.data);
        //     }
        // }).catch(() => {
        //     this.props.history.push('/houjin/home');
        // })
    }
    componentDidUpdate(prevProps){
        if(prevProps.jobs !== this.props.jobs){
            this.setData(this.props.jobs);
        }
    }
    setData(data) {
        if (data.length) {
            data.map((job,index) => {
                let images = job.images;
                let images_path = job.images_path;
                let original_images_path = job.images_path;
                let imgState = [];
                images_path.map((img, index) => {
                    imgState.push({
                        url: original_images_path[index],
                        url_crop: img,
                        selected: images[index].is_selected,
                        rotate: 0
                    });
                })
                job.images = imgState
            })
        }
        this.setState({
            jobs: data
        })
    }
    handleChangeEditPostPeriodStartDate(date,e,i) {
        // let jobData = Object.assign({}, this.state.jobs);
        // const jobData = [...this.state.jobs];
        let jobs = this.getData();
        jobs[i].post_period_start_date = date;
        this.props.dispatch(
            updateStateJobs(Object.assign({}, {jobs:jobs}))
        );
        this.setState({jobs: jobs});
    }
    handleChangeEditPostPeriodEndDate(date,e,i) {
        // let jobData = Object.assign({}, this.state.jobs);
        // const jobData = [...this.state.jobs];
        let jobs = this.getData();
        jobs[i].post_period_end_date = date;
        this.props.dispatch(
            updateStateJobs(Object.assign({}, {jobs:jobs}))
        );
        this.setState({jobs: jobs});
    }
    handleChangeBulkEditPostPeriodStartDate(date,e){
        if(this.state.jobs.length){
            this.state.jobs.map((job, i) => {
                this.handleChangeEditPostPeriodStartDate(date,e,i)
            });
            this.setState({bulk_post_period_start_date:date});
        }
    }
    handleChangeBulkEditPostPeriodEndDate(date,e){
        if(this.state.jobs.length){
            this.state.jobs.map((job, i) => {
                this.handleChangeEditPostPeriodEndDate(date,e,i)
            });
            this.setState({bulk_post_period_end_date:date});
        }
    }
    /**
     * Get data of job
     */
    getData() {
        return this.state.jobs;
    }

    /**
     * Handle redirect
     */
    handleRedirect(e) {
        e.preventDefault()
        this.props.history.push(e.currentTarget.getAttribute('href'));
    }

    /**
     * Call function save data from element parent
     */
    saveData(e) {
        e.preventDefault()
        //to top
        window.scrollTo(0, 0)
        let jobs = this.getData();

        // job['old_images'] = job.is_copy ? job.old_images : [];
        // jobs['old_images'] = [];
        // jobs['images'] = this.state.images;

        axios.post('/api/houjin/jobs/bulk-create', {jobs:jobs})
        .then(response => {
            if (response.data.success) {
                this.props.dispatch(
                    initSelectedIdList(Object.assign({}))
                );
                this.props.history.push({
                    pathname: '/houjin/jobs',
                    state: { message_success: response.data.message }
                });
            } else {
                Object.keys(response.data.errors).map((key, i) => {
                        if($.isArray(response.data.errors[key])){
                            response.data.errors[key].map((child, i) => {
                                toast.error(child)
                            })
                        } else {
                            toast.error(response.data.errors[key])
                        }
                    }
                )
            }
        }).catch(error => {
            Object.keys(error.response.data.errors).map((key, i) => {
                    if($.isArray(error.response.data.errors[key])){
                        error.response.data.errors[key].map((child, i) => {
                            toast.error(child)
                        })
                    } else {
                        toast.error(error.response.data.errors[key])
                    }
                }
            )
        })
    }

    handleDateChangeRaw(e) {
        e.preventDefault();
    }

    handleEditCopyJob(link,e,index) {
        this.props.dispatch(
            updateStateJobs(Object.assign({}, {currentEditingJobIndex:index}))
        );
        this.props.history.push({
            pathname: link
        })
    }

    render() {
        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-sm-12">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item"><a onClick={this.handleRedirect} href="/houjin/home">ダッシュボード</a></li>
                                <li className="breadcrumb-item"><a onClick={this.handleRedirect} href="/houjin/jobs">依頼一覧</a></li>
                                <li className="breadcrumb-item active" aria-current="page">一括コピー</li>
                            </ol>
                        </nav>
                    </div>
                </div>
                <main id="main">
                    <div className="row justify-content-md-center">
                        <div className="col-sm-6">
                            <div className="card">
                                <div className="p-4 border-bottom-0 mt-2 mb-4"><h4 className="mb-0">選択中の依頼一覧</h4></div>
                                {/* <div>
                                    <div className="form-group row mb-0">
                                        <div className="col-4 col-sm-3 input-group pr-2">
                                            <DatePicker
                                                locale="ja-JP"
                                                className="form-control form_datepicker"
                                                dateFormat="YYYY/MM/DD"
                                                selected={this.state.bulk_post_period_start_date ? moment(new Date(this.state.bulk_post_period_start_date)) : null}
                                                selectsStart
                                                onChange={(selectedDate, e) => {this.handleChangeBulkEditPostPeriodStartDate(selectedDate, e)}}
                                                minDate={moment()}
                                                placeholderText="2023/02/01"
                                                disabledKeyboardNavigation
                                                startDate={this.state.bulk_post_period_start_date}
                                                endDate={this.state.bulk_post_period_end_date}
                                                style={{backgroundColor:'#FFF2F2'}}
                                            />
                                            <div className="input-group-append job-input-group-append">
                                                <button className="btn btn-outline-secondary d-none" type="button" id="form-calendar"><i className="material-icons">calendar_today</i></button>
                                            </div>
                                        </div>
                                        <div className="text-center pt-2">
                                            <span>～</span>
                                        </div>
                                        <div className="col-4 col-sm-3 input-group pl-2">
                                            <DatePicker
                                                locale="ja-JP"
                                                className="form-control form_datepicker"
                                                dateFormat="YYYY/MM/DD"
                                                selected={this.state.bulk_post_period_end_date ? moment(new Date(this.state.bulk_post_period_end_date)) : null}
                                                selectsEnd
                                                onChange={(selectedDate, e) => {this.handleChangeBulkEditPostPeriodEndDate(selectedDate, e)}}
                                                minDate={moment()}
                                                placeholderText="2023/02/28"
                                                disabledKeyboardNavigation
                                                startDate={this.state.bulk_post_period_start_date}
                                                endDate={this.state.bulk_post_period_end_date}
                                                style={{backgroundColor:'#FFF2F2'}}
                                            />
                                            <div className="input-group-append job-input-group-append">
                                                <button className="btn btn-outline-secondary d-none" type="button" id="form-calendar"><i className="material-icons">calendar_today</i></button>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                                <div className="">
                                     {/* 期間を一括指定 */}
                                    <div class="form-group row ml-0 mr-0">
                                        <div class="col-3 col-sm-3 pt-sm-2 pl-4 pr-0">期間を一括指定</div>
                                        <div class="col-4 col-sm-3 input-group pl-0 pr-0 w-100">
                                            <DatePicker
                                                locale="ja-JP"
                                                className="form-control form_datepicker"
                                                dateFormat="YYYY/MM/DD"
                                                selected={this.state.bulk_post_period_start_date ? moment(new Date(this.state.bulk_post_period_start_date)) : null}
                                                selectsStart
                                                onChange={(selectedDate, e) => {this.handleChangeBulkEditPostPeriodStartDate(selectedDate, e)}}
                                                minDate={moment()}
                                                placeholderText="2023/02/01"
                                                disabledKeyboardNavigation
                                                startDate={this.state.bulk_post_period_start_date}
                                                endDate={this.state.bulk_post_period_end_date}
                                                style={{backgroundColor:'#FFF2F2'}}
                                            />
                                            <div className="input-group-append job-input-group-append">
                                                <button className="btn btn-outline-secondary d-none" type="button" id="form-calendar"><i className="material-icons">calendar_today</i></button>
                                            </div>
                                        </div>
                                        <div class="text-center pt-2 pl-1 pr-0">
                                            <span>～</span>
                                        </div>
                                        <div class="col-4 col-sm-3 input-group pl-2 pl-0 pr-0">
                                            <DatePicker
                                                locale="ja-JP"
                                                className="form-control form_datepicker"
                                                dateFormat="YYYY/MM/DD"
                                                selected={this.state.bulk_post_period_end_date ? moment(new Date(this.state.bulk_post_period_end_date)) : null}
                                                selectsEnd
                                                onChange={(selectedDate, e) => {this.handleChangeBulkEditPostPeriodEndDate(selectedDate, e)}}
                                                minDate={moment()}
                                                placeholderText="2023/02/28"
                                                disabledKeyboardNavigation
                                                startDate={this.state.bulk_post_period_start_date}
                                                endDate={this.state.bulk_post_period_end_date}
                                                style={{backgroundColor:'#FFF2F2'}}
                                            />
                                            <div className="input-group-append job-input-group-append">
                                                <button className="btn btn-outline-secondary d-none" type="button" id="form-calendar"><i className="material-icons">calendar_today</i></button>
                                            </div>
                                        </div>
                                    </div>

                                    {this.state.jobs.length ? this.state.jobs.map((job, i) => {
                                        return (
                                            <div className="p-4 border-top" key={i}>
                                                <div className="form-group row">
                                                    <div className="col-sm-8">
                                                        {job.free_category}
                                                    </div>
                                                    <div className="col-sm-8">
                                                        {job.prefName}{job.cityName}{job.address}{job.address2}
                                                    </div>
                                                </div>
                                                <div className="form-group row mb-0">
                                                    <div className="col-4 col-sm-3 input-group pr-2">
                                                        <DatePicker
                                                            locale="ja-JP"
                                                            className="form-control form_datepicker"
                                                            dateFormat="YYYY/MM/DD"
                                                            selected={job.post_period_start_date ? moment(new Date(job.post_period_start_date)) : null}
                                                            selectsStart
                                                            onChange={(selectedDate, e) => { this.handleChangeEditPostPeriodStartDate(selectedDate, e, i) }}
                                                            minDate={moment()}
                                                            placeholderText="2023/02/01"
                                                            disabledKeyboardNavigation
                                                            startDate={job.post_period_start_date}
                                                            endDate={job.post_period_end_date}
                                                            style={{backgroundColor:'#FFF2F2'}}
                                                        />
                                                        <div className="input-group-append job-input-group-append">
                                                            <button className="btn btn-outline-secondary d-none" type="button" id="form-calendar"><i className="material-icons">calendar_today</i></button>
                                                        </div>
                                                    </div>
                                                    <div className="text-center pt-2">
                                                        <span>～</span>
                                                    </div>
                                                    <div className="col-4 col-sm-3 input-group pl-2">
                                                        <DatePicker
                                                            locale="ja-JP"
                                                            className="form-control form_datepicker"
                                                            dateFormat="YYYY/MM/DD"
                                                            selected={job.post_period_end_date ? moment(new Date(job.post_period_end_date)) : null}
                                                            selectsEnd
                                                            onChange={(selectedDate, e) => { this.handleChangeEditPostPeriodEndDate(selectedDate, e, i) }}
                                                            minDate={moment()}
                                                            placeholderText="2023/02/28"
                                                            disabledKeyboardNavigation
                                                            startDate={job.post_period_start_date}
                                                            endDate={job.post_period_end_date}
                                                            style={{backgroundColor:'#FFF2F2'}}
                                                        />
                                                        <div className="input-group-append job-input-group-append">
                                                            <button className="btn btn-outline-secondary d-none" type="button" id="form-calendar"><i className="material-icons">calendar_today</i></button>
                                                        </div>
                                                    </div>
                                                    <div className="col text-right">
                                                        <button type="button" className="btn pt-2 pb-2 font-weight-normal col-12 col-sm-5 text-dark" style={{backgroundColor: '#EEEEEE'}}onClick={(e) => this.handleEditCopyJob("/houjin/jobs/copy/edit",e,i)}>詳細編集</button>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    }):''}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="card-footer">
                                        <div className="text-center">
                                            <button onClick={this.handleRedirect} href="/houjin/jobs" className="btn bg-white btn-radius btn-lg mr-3"><span className="size-inherit font-weight-normal text-dark">戻る</span></button>
                                            <button onClick={this.saveData} className="btn btn-primary btn-radius btn-lg clearfix"><span className="size-inherit pl-5 pr-5">一括登録</span></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
                <ToastContainer />
            </React.Fragment>
        )
    }
}
const mapStateToProps = state => {
    const {jobs,selectedJobIds} = state.job

    return {
        jobs: jobs,
        selectedJobIds: selectedJobIds,
    }
}

export default withRouter(connect(mapStateToProps)(CopyJob))
